<template>
  <div class="form-checkbox">
    <FormTitle
      :required="Boolean(data.is_must_answer)"
      :title="data.title"
      :desc="data.title_details"
      style="margin-bottom: 10px"
    />
    <gkFormCustomGroup
      :field="data.id.toString()"
      :rule="isValidity ? rules : []"
      :validity="isValidity"
      v-model="value"
    >
      <template v-for="(option, i) in options">
        <div class="item" :key="i">
          <gkFormCheck
            class="my-form-check"
            type="checkbox"
            color="infoqCheckbox"
            :value="`${option.key}${dataConcatStr}${option.title}${dataConcatStr}${data.type}`"
            :label="option.title"
            @change="handleChange($event)"
            v-model="value"
          />
        </div>
      </template>
    </gkFormCustomGroup>
  </div>

</template>
<script>
import VueTypes from 'vue-types'

import gkFormCheck from 'gkui/form/FormCheck'
import gkFormCustomGroup from 'gkui/form/FormCustomGroup'
import FormTitle from '@/components/FormTitle'
import * as COMPONENT_CONST from '../const'

import config from '@/config'

export default {
  name: 'direction-interest',
  props: {
    data: VueTypes.object,
    answer: VueTypes.object,
    userFieldInfo: VueTypes.object.def({})
  },
  components: {
    gkFormCustomGroup,
    gkFormCheck,
    FormTitle
  },
  data () {
    return {
      value: [],
      COMPONENT_CONST,

      dataConcatStr: config.dataConcatStr
    }
  },
  watch: {
    userFieldInfo: {
      handler: function (newData, oldData) {
        try {
          // eslint-disable-next-line camelcase
          const extraInfo = this.data?.extra_info && JSON.parse(this.data.extra_info)
          if (!extraInfo) {
            return
          }
          const { user_attribute: key } = extraInfo
          if (newData !== oldData && key && newData[key]) {
            const value = newData[key]
            const info = this.options.filter(ele => value.includes(ele.title))
            const ret = info.map(ele => `${ele.key}${this.dataConcatStr}${ele.title}${this.dataConcatStr}${this.data.type}`)
            this.value = ret
          }
        } catch (e) {
          console.log(e)
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    options () {
      return this.data.details.options
    },
    rules () {
      let rule = []
      if (this.data.is_must_answer) {
        rule.push({
          required: '请选择至少一项'
        })
      }
      return rule
    },
    isValidity () {
      return Boolean(this.data.showQuestion)
    }
  },
  methods: {
    handleChange ($event) {
      this.value = $event
      if (this.value.length > 3) {
        this.$Message.toast({
          message: '最多只能选择三项'
        })
        this.value.pop()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../assets/css/_common";

.form-checkbox {

  & .item {
    display: flex;
    align-items: center;
    min-height: 22px;
    padding: 8px 0;

    &:last-child {
      padding-bottom: 0;
    }

    & .my-form-check {
      align-items: flex-start;
      flex: none;
      max-width: 100%;
    }

    & ::v-deep {
      & .gkui-form-element[data-color="gray"] {
        min-height: 22px;

        & .gkui-form-error {
          bottom: -88%;
        }
      }

      & [gkcheck-color="infoqCheckbox"] {
        flex: none;
        width: 18px; height: 18px;
        margin-top: 2px;
      }

      & [gkcheck-color="infoqCheckbox"] + span {
        font-size: 16px; line-height: 22px;
        color: $bodyBlack;
        word-break: break-all;
      }

      & [checked="checked"] + span {
        color: $blue;
      }

      & [gkcheck-color="infoqCheckbox"][checked="checked"] {
        border: 1px solid $blue;
        background: $blue;

        & span {
          width: 100%; height: 100%;
        }
      }

      & [gkcheck-color="infoqCheckbox"] [gk-checked]:after {
        left: 3px; top: 3px;
        width: 11px; height: 6px;
        border-left: 2px solid #ffffff; border-bottom: 2px solid #ffffff;
      }
    }

    & [data-size="small"] {
      flex: 1;
      height: 22px;
      border: none; border-bottom: 1px solid #4A4A4A; border-radius: 0;
    }

  }
}

@media screen and (max-width: 768px) {
  .form-checkbox .item .other ::v-deep .gkui-form-element {
    width: 100px;
  }
}
</style>
